import React from 'react';

const privacySections = [
  {
    title: '1. Introduction',
    body: `Welcome to Fit-Mate24. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application. By using Fit-Mate24, you agree to the terms outlined in this policy. If you disagree, please do not use the app.

This Policy applies to all personal data collected by Fit-Mate24 through the app. For questions, contact: privacy@fit-mate24.com`,
  },
  {
    title: '2. Data Collection',
    body: `We may collect and process the following categories of personal data:
• Contact information (name, email address, etc.)
• Account details (username, password)
• Usage data (interactions, preferences, etc.)
• Device information (IP address, device model, etc.)
• Fitness data (as provided by you)
• Any other information voluntarily submitted via the app

Personal data is collected either:
• Directly from you when submitting information, or
• Automatically as you interact with the app.`,
  },
  {
    title: '3. Legal Basis for Processing',
    body: `We process your data based on the following grounds:
• Performance of a contract (to provide you the service)
• Compliance with legal obligations
• Legitimate interests (improving our services)
• Consent (where required for processing specific data)`,
  },
  {
    title: '4. How We Use Your Data',
    body: `Your personal data may be used to:
• Provide and maintain the Fit-Mate24 service
• Personalize the app experience
• Communicate with you (including updates)
• Analyze usage and improve the app
• Ensure security and prevent fraud
• Comply with legal or regulatory obligations`,
  },
  {
    title: '5. Data Sharing and Disclosure',
    body: `Fit-Mate24 may share your data in the following circumstances:
• With service providers assisting in service delivery
• When required by law or to protect our rights
• In connection with business transfers (e.g., merger or sale)
Your data will not be sold to third parties for marketing.`,
  },
  {
    title: '6. Data Retention',
    body: `Your personal data is retained only as long as necessary for the purposes described in this policy, or to comply with legal requirements. Data may be anonymized for analytical purposes.`,
  },
  {
    title: '7. Your Rights and Choices',
    body: `Depending on your location, you may have the right to:
• Access, correct, or delete your personal data
• Object to or restrict certain processing
• Withdraw consent where processing is based on consent
• Lodge a complaint with a supervisory authority

To exercise these rights, contact privacy@fit-mate24.com`,
  },
  {
    title: '8. Age Requirement',
    body: `Fit-Mate24 is not intended for children under 18. We do not knowingly collect information from anyone under this age.`,
  },
  {
    title: '9. Changes to this Privacy Policy',
    body: `We may update this Privacy Policy periodically. Changes will be communicated via the app or website. Review regularly for updates.`,
  },
  {
    title: '10. Contact Information',
    body: `For questions about this Privacy Policy or data practices, contact:
Email: privacy@fit-mate24.com
Fit-Mate24, Berlin, Germany`,
  },
  {
    title: '11. Language & Conflicts',
    body: `This policy may be provided in multiple languages. In case of inconsistencies, the English version shall prevail.`,
  },
];

const pageStyle = {
  minHeight: '100vh',
  // width: '100vw',
  margin: 0,
  overflowX: 'hidden', // prevent horizontal scroll on body
  display: 'flex',
  justifyContent: 'center',
  boxSizing: 'border-box',
};

const cardStyle = {
  background: '#18181a',
  color: 'white',
  boxShadow: '0 5px 24px #000a',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  padding: 24,
  // maxWidth: 600,       // limit max width to avoid overflow
  width: '100%',       // responsive width
  overflowWrap: 'break-word', // break long words/links
  wordWrap: 'break-word',     // fallback
  boxSizing: 'border-box',
};


const headerStyle = {
  fontSize: 28,
  fontWeight: 600,
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  marginBottom: 14,
  textAlign: 'center',
};

const dateStyle = {
  fontSize: 12,
  marginBottom: 20,
  color: '#bbb',
  textAlign: 'center',
};

export default function PrivacyPolicy() {
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={headerStyle}>
          Privacy Policy for
          <br />
          Fit-Mate24
        </div>
        <div style={dateStyle}>Effective: 1 January 2023</div>
        {privacySections.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 20 }}>
            <strong>{section.title}</strong>
            <div style={{ fontSize: 15, marginTop: 4, whiteSpace: 'pre-line' }}>{section.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
